/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TransportPortableBicycleIcon16Light } from './TransportPortableBicycleIcon16Light';
import { TransportPortableBicycleIcon16Regular } from './TransportPortableBicycleIcon16Regular';
import { TransportPortableBicycleIcon16Solid } from './TransportPortableBicycleIcon16Solid';
import { TransportPortableBicycleIcon20Light } from './TransportPortableBicycleIcon20Light';
import { TransportPortableBicycleIcon20Regular } from './TransportPortableBicycleIcon20Regular';
import { TransportPortableBicycleIcon20Solid } from './TransportPortableBicycleIcon20Solid';
import { TransportPortableBicycleIcon24Regular } from './TransportPortableBicycleIcon24Regular';
import { TransportPortableBicycleIcon24Solid } from './TransportPortableBicycleIcon24Solid';
import { TransportPortableBicycleIcon32Regular } from './TransportPortableBicycleIcon32Regular';
import { TransportPortableBicycleIcon64Regular } from './TransportPortableBicycleIcon64Regular';
var sizes = {
    16: {
        light: TransportPortableBicycleIcon16Light,
        regular: TransportPortableBicycleIcon16Regular,
        solid: TransportPortableBicycleIcon16Solid,
    },
    20: {
        light: TransportPortableBicycleIcon20Light,
        regular: TransportPortableBicycleIcon20Regular,
        solid: TransportPortableBicycleIcon20Solid,
    },
    24: {
        regular: TransportPortableBicycleIcon24Regular,
        solid: TransportPortableBicycleIcon24Solid,
    },
    32: {
        regular: TransportPortableBicycleIcon32Regular,
    },
    64: {
        regular: TransportPortableBicycleIcon64Regular,
    },
};
export var TransportPortableBicycleIcon = forwardRef('TransportPortableBicycleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
